import React, { useContext, useEffect, useState } from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import cls from './DebitModal.module.css';
import { Editable } from '../../../../../components/UI/Editable/Editable';
import { FileInput } from '../../../../../components/UI/FileInput/FileInput';
import { FormBlock } from '../../../../../components/UI/Form/FormBlock/FormBlock';
import { Select } from '../../../../../components/UI/Select/Select';
import { Textarea } from '../../../../../components/UI/Textarea/Textarea';
import { Input } from '../../../../../components/UI/TextInput/Input';
import { ModalContext } from '../AddPaymentModal';
import { DistributeAmount } from '../DistributeAmount/DistributeAmount';

export const DebitModal = ({ modalState, accountsSelectList, setModalState }) => {
    const partnersSelectList = useSelector((state) => state.paymentReducer.partnersSelectList);
    const allExpense = useSelector((state) => state.paymentReducer.expenseList);
    const allIncome = useSelector((state) => state.paymentReducer.incomeList);
    const estimatesSelectList = useSelector((state) => state.paymentReducer.estimatesSelectList);

    const partnersListWithButton = [
        {
            title: i18next.t('DebitModal.partnersListWithButton.title.null'),
            value: null,
        },
        {
            title: i18next.t('DebitModal.partnersListWithButton.title.add'),
            isButton: true,
            buttonHandler: () => {
                setModalState((prevState) => ({
                    ...prevState,
                    isOpenPartners: true,
                }));
                setFormState((prevState) => ({ ...prevState, partners: null }));
            },
            value: '',
        },
        ...partnersSelectList,
    ];

    const {
        selectedPartners,
        selectedFirstStepAccount,
        selectEstimateHandler,
        selectFirstStepAccountHandler,
        selectPartnersHandler,
        selectExpenditureHandler,
        inputHandler,
        formState,
        setFormState,
        errors,
        selectedAccount,
        mode,
        sumFormHandler,
        handleIsFirstRenderDebit,
        isFirstRenderDebit,
    } = useContext(ModalContext);

    const [images, setImages] = useState('');
    const [accountValue, setAccountValue] = useState(accountsSelectList[0] || null);

    // синхронизирую значения со стором при первом рендере
    useEffect(() => {
        if (!isFirstRenderDebit) {
            if (modalState.addPaymentMode === 'repeat' && modalState.mode === 'transfer') {
                const foundedAcc = accountsSelectList?.find(
                    (acc) => acc.value === selectedFirstStepAccount?.value
                );

                setAccountValue(foundedAcc);
            } else {
                const existingAccount = accountsSelectList.find(
                    (acc) => acc?.value === formState.firstStepAccount
                );

                if (existingAccount) {
                    setAccountValue(existingAccount);
                } else {
                    selectFirstStepAccountHandler(accountsSelectList[0]?.value || null);
                }
            }
            handleIsFirstRenderDebit();
        } else if (selectedFirstStepAccount?.value === accountValue?.value) {
            setAccountValue(
                accountsSelectList?.filter(
                    (acc) => acc.value !== selectedFirstStepAccount?.value
                )[0]
            );
        } else {
            setAccountValue(() => {
                const inAccounts = accountsSelectList?.find(
                    (acc) => acc.value === selectedFirstStepAccount?.value
                );
                if (inAccounts) {
                    return selectedFirstStepAccount;
                }
                selectFirstStepAccountHandler(accountValue?.value);
                return accountValue;
            });
        }
    }, []);

    const handleForm = (e) => {
        const images = e.currentTarget.files;
        setFormState((prevState) => ({ ...prevState, invoicePayment: Object.values(images) }));
        const inputText = Object.values(images)
            .map((image) => image.name)
            .join(', ');
        setImages(inputText);
    };

    useEffect(() => {
        if (!formState.expenditures) {
            if (modalState.mode === 'debit') {
                setFormState((prev) => ({ ...prev, expenditures: allIncome[0].value }));
            } else setFormState((prev) => ({ ...prev, expenditures: allExpense[0].value }));
        }
    }, []);

    const selectedExpense = allExpense.find((account) => account.value === formState.expenditures);
    const selectedIncome = allIncome.find((account) => account.value === formState.expenditures);
    const selectedEstimate = estimatesSelectList.find(
        (estimate) => estimate.value === formState.estimates
    );

    let isDisabledReceiveSum = true;

    if (selectedFirstStepAccount) {
        isDisabledReceiveSum =
            selectedFirstStepAccount.account.currency.sign ===
            selectedAccount.account.currency.sign;
    }

    const handleSelectAccount = (value) => {
        setAccountValue(() => accountsSelectList.find((acc) => acc.value === value));
        selectFirstStepAccountHandler(value);
    };
    return (
        <>
            {modalState.isBetweenAccount && !selectedAccount.account.integration && (
                <FormBlock>
                    <div className={classNames(cls.blockWrapper)}>
                        <Input
                            isRequired
                            title={
                                modalState.mode === 'debit'
                                    ? i18next.t('DebitModal.return.debit')
                                    : i18next.t('DebitModal.return.credit')
                            }
                            name="sum"
                            value={formState.sum}
                            onChange={sumFormHandler}
                            icon={selectedAccount.account.currency.sign}
                            error={errors.sum}
                        />
                    </div>
                    <div className={classNames(cls.blockWrapper)} />
                </FormBlock>
            )}
            {selectedAccount.account.integration === null && (
                <FormBlock>
                    <div
                        className={classNames(cls.blockWrapperSingle, {
                            [cls.blockWrapper]:
                                modalState.isBetweenAccount && !selectedAccount.account.integration,
                        })}
                    >
                        {modalState.isBetweenAccount ? (
                            <Select
                                isSmartPosition
                                selected={accountValue}
                                onChange={handleSelectAccount}
                                placeholder={
                                    modalState.mode === 'debit'
                                        ? i18next.t('DebitModal.return.writeOffAccount')
                                        : i18next.t('DebitModal.return.receiptAccount')
                                }
                                title={
                                    modalState.mode === 'debit'
                                        ? i18next.t('DebitModal.return.writeOffAccount')
                                        : i18next.t('DebitModal.return.receiptAccount')
                                }
                                isRequired
                                isAccount
                                options={accountsSelectList}
                                error={errors.receiverAccount}
                            />
                        ) : (
                            <Select
                                isSmartPosition
                                selected={selectedPartners || null}
                                onChange={selectPartnersHandler}
                                placeholder={i18next.t('DebitModal.selectedPartners.placeholder')}
                                title={i18next.t('DebitModal.selectedPartners.title')}
                                isRequired={false}
                                options={partnersListWithButton}
                                error={errors.correspondent}
                            />
                        )}
                    </div>
                    {modalState.isBetweenAccount && !selectedAccount.account.integration && (
                        <div className={classNames(cls.blockWrapper)}>
                            <Editable
                                secondName="receiveSum"
                                mainName="sum"
                                isDisabled={isDisabledReceiveSum}
                                valueMain={formState.sum}
                                valueSecond={formState.receiveSum}
                                handler={sumFormHandler}
                                title={
                                    modalState.mode === 'credit' || modalState.mode === 'transfer'
                                        ? i18next.t('DebitModal.return.debit')
                                        : i18next.t('DebitModal.return.credit')
                                }
                                icon={
                                    selectedFirstStepAccount
                                        ? selectedFirstStepAccount.account.currency.sign
                                        : selectedAccount.account.currency.sign
                                }
                                error={errors.receiveSum}
                            />
                        </div>
                    )}
                </FormBlock>
            )}
            <FormBlock>
                {!(modalState.isBetweenAccount && !selectedAccount.account.integration) && (
                    <div className={classNames(cls.blockWrapper)}>
                        <Input
                            isRequired
                            title={i18next.t('DebitModal.blockWrapper.title')}
                            name="sum"
                            value={formState.sum}
                            onChange={sumFormHandler}
                            icon={selectedAccount.account.currency.sign}
                            error={errors.sum}
                            isDisabled={mode === 'distribution'}
                        />
                    </div>
                )}
                <div
                    className={classNames(cls.blockWrapperSingle, {
                        [cls.blockWrapper]: !(
                            modalState.isBetweenAccount && !selectedAccount.account.integration
                        ),
                    })}
                >
                    {modalState.isBetweenAccount ? (
                        <Input
                            isRequired
                            title={i18next.t('DebitModal.blockWrapper.isBetweenAccount.title')}
                            name="purposePayment"
                            value={formState.purposePayment}
                            onChange={(event) => inputHandler(event)}
                            error={errors.purposePayment}
                            isDisabled={mode === 'distribution'}
                        />
                    ) : (
                        <Select
                            isSmartPosition
                            selected={
                                modalState.mode === 'credit' ? selectedExpense : selectedIncome
                            }
                            onChange={selectExpenditureHandler}
                            placeholder={i18next.t('DebitModal.selectExpenditure.placeholder')}
                            title={
                                modalState.mode === 'credit'
                                    ? i18next.t('DebitModal.selectExpenditure.title.credit')
                                    : i18next.t('DebitModal.selectExpenditure.title.debit')
                            }
                            isRequired
                            options={modalState.mode === 'credit' ? allExpense : allIncome}
                            error={errors.paymentItem}
                        />
                    )}
                </div>
            </FormBlock>
            {!modalState.isBetweenAccount && (
                <>
                    {!formState.distributeEstimates.length && (
                        <FormBlock>
                            <Select
                                isSmartPosition
                                selected={selectedEstimate || null}
                                onChange={selectEstimateHandler}
                                placeholder={i18next.t('DebitModal.selectedEstimate.placeholder')}
                                title={i18next.t('DebitModal.selectedEstimate.title')}
                                options={estimatesSelectList}
                                error={!formState.distributeEstimates.length && errors.estimate}
                            />
                        </FormBlock>
                    )}
                    <FormBlock>
                        <DistributeAmount
                            formState={formState}
                            setFormState={setFormState}
                            error={!!formState.distributeEstimates.length && errors.estimate}
                        />
                    </FormBlock>
                    <FormBlock>
                        <Input
                            isRequired
                            title={i18next.t('DebitModal.purposePayment.title')}
                            name="purposePayment"
                            value={formState.purposePayment}
                            onChange={(event) => inputHandler(event)}
                            icon={null}
                            error={errors.purposePayment}
                            isDisabled={mode === 'distribution'}
                        />
                    </FormBlock>
                </>
            )}

            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Textarea
                        isRequired={false}
                        title={i18next.t('DebitModal.comment.title')}
                        name="comment"
                        value={formState.comment}
                        onChange={(event) => inputHandler(event)}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <FileInput
                        fileText={images}
                        isRequired={false}
                        error={errors.attachments}
                        title={i18next.t('DebitModal.invoicePayment.title')}
                        name="invoicePayment"
                        value={formState.invoicePayment}
                        onChange={handleForm}
                    />
                </div>
            </FormBlock>
        </>
    );
};
